import { createActionGroup, props } from '@ngrx/store';
import { DeviceInformation } from './device-information.state';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceInformationResolverActions = createActionGroup({
  source: 'DeviceInformation Resolver',
  events: {
    'Device Requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceInformationApiActions = createActionGroup({
  source: 'DeviceInformation API',
  events: {
    'Device Loaded': props<{ deviceInformation: DeviceInformation }>(),
    'Device Loaded Error': props<{ error: ErrorModel }>(),
  },
});
